import { useNavigate } from 'react-router-dom';
import { Logo } from './Logo';
import { signInWithGoogle, db } from '../lib/firebase';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

export function Footer() {
  const navigate = useNavigate();

  const handleLogin = async (role?: 'stand' | 'festival') => {
    try {
      const user = await signInWithGoogle();
      
      if (user && role) {
        const userRef = doc(db, 'users', user.uid);
        const userSnap = await getDoc(userRef);
        
        if (!userSnap.exists()) {
          await setDoc(userRef, {
            name: user.displayName || 'Utilisateur',
            email: user.email || '',
            role: role,
            createdAt: serverTimestamp()
          });
          sessionStorage.setItem(`userRole_${user.uid}`, role);
        } else {
          const existingRole = userSnap.data().role;
          if (!existingRole) {
              await setDoc(userRef, { role, updatedAt: serverTimestamp() }, { merge: true });
              sessionStorage.setItem(`userRole_${user.uid}`, role);
          } else {
              sessionStorage.setItem(`userRole_${user.uid}`, existingRole);
              role = existingRole; 
          }
        }
      }
      navigate('/home', { state: { role: role } });
    } catch (error: any) {
      if (error?.code !== 'auth/popup-closed-by-user' && error?.code !== 'auth/cancelled-popup-request') {
        console.error("Login failed", error);
      }
    }
  };

  return (
    <footer className="bg-[#0d0e12] border-t border-white/5 py-16 md:py-32 px-6 md:px-10 lg:px-20 relative z-20 overflow-hidden">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-[300px] md:h-[600px] bg-[#ff5a00]/5 rounded-full blur-[100px] md:blur-[200px] pointer-events-none"></div>
      
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-24 relative z-10">
        <div className="space-y-8 md:space-y-12">
          <Logo className="text-3xl md:text-4xl" />
          <p className="text-gray-500 text-sm md:text-base leading-relaxed max-w-xs font-medium">
            L'outil d'excellence pour la gestion logistique des événements majeurs. Conçu pour les bâtisseurs de festivals.
          </p>
        </div>

        <div>
          <h5 className="font-black uppercase tracking-[0.3em] text-[10px] text-[#ff5a00] mb-12">Plateforme</h5>
          <ul className="space-y-6 text-sm md:text-base text-gray-500 font-bold uppercase tracking-tight">
            <li><button onClick={() => handleLogin('festival')} className="hover:text-white transition-colors">Festivals</button></li>
            <li><button onClick={() => handleLogin('stand')} className="hover:text-white transition-colors">Exposants</button></li>
            <li><button onClick={() => navigate('/vision')} className="hover:text-white transition-colors">Notre Vision</button></li>
            <li><button onClick={() => navigate('/tarification')} className="hover:text-white transition-colors">Tarification</button></li>
          </ul>
        </div>

        <div>
          <h5 className="font-black uppercase tracking-[0.3em] text-[10px] text-[#ff5a00] mb-12">Ressources</h5>
          <ul className="space-y-6 text-sm md:text-base text-gray-500 font-bold uppercase tracking-tight">
            <li><button onClick={() => navigate('/support')} className="hover:text-white transition-colors">Centre d'Aide</button></li>
            <li><button onClick={() => navigate('/privacy')} className="hover:text-white transition-colors">Confidentialité</button></li>
            <li><button onClick={() => navigate('/terms')} className="hover:text-white transition-colors">Conditions Générales</button></li>
            <li><button onClick={() => navigate('/contact')} className="hover:text-white transition-colors">Contact Expert</button></li>
          </ul>
        </div>
      </div>
      
      <div className="max-w-[1400px] mx-auto mt-20 md:mt-40 pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between items-center text-[8px] md:text-[10px] font-black uppercase tracking-[0.3em] md:tracking-[0.5em] text-gray-600 italic text-center md:text-left space-y-6 md:space-y-0">
        <div>© 2024 FESTIN HUB. OPERATIONAL SYSTEM DESIGNED FOR SCALE.</div>
        <div className="flex space-x-6 md:space-x-12">
          <span className="hover:text-white cursor-pointer transition-colors">HQ: PARIS / FR</span>
          <span className="hover:text-white cursor-pointer transition-colors">SERVER STATUS: OPS</span>
        </div>
      </div>
    </footer>
  );
}
